// ©2024 Austin App House. All rights reserved.
import React from 'react';
import { Field } from 'redux-form';
const Electronic1099Section = () => (
    <div className="form_section">
        <div className="modal_title">Electronic 1099</div>
        <div className="certification_modal__check-row">
            <label className="wo-check-btn check_btn">
                <Field name="isElectronic1099Checked" component="input" type="checkbox" />
                <span className="certification_modal__check-label">I would like to save paper and receive my 1099 electronically.</span>
            </label>
        </div>
    </div>
);

export default Electronic1099Section;
